<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="1200px">
      <v-card class="insights-dialog">
        <v-card-title>
          <span class="headline"><v-icon class="pr-2">add_circle_outline</v-icon>View Report: "{{reportName}}"</span>
        </v-card-title>
        <v-card-text>

          <v-tabs
            v-model="state.tabs"
            slot="extension"
            left
            color="transparent"
            slider-color="blue"
          >
            <v-tab
              v-for="(item, ind) in state.sheet"
              :key="ind"
            >
              <div class="tab-item">{{ item.sheetName }}</div>
            </v-tab>
          </v-tabs>

          <v-tabs-items
            v-model="state.tabs"
          >
            <v-tab-item
              v-for="(sheet, si) in state.sheet"
              :key="si"
            >
              <div class="row">
            <div class="col-md-12">
              <table class="table table-striped table-hover table-condensed table-responsive">
                <thead>
                <tr>
                  <th v-for="(item, index) in sheet.headers" :key="index">{{item}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in sheet.tickets" :key="index">
                  <td v-for="(key, ind) in item" :key="ind">
                    <label>{{key}}</label>
                    <p>{{item.key}}</p>
                  </td>
                </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </div>
          </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-on:click="closeDialog" color="blue darken-1" flat>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {eventEmitter} from '../../main'
import ReportMixin from '../../mixins/reportMixin'
export default {
  name: 'ReportPreview',
  mixins: [ReportMixin],
  props: {
    dialog: {
      default: false,
      type: Boolean
    },
    reportName: {
      default: '',
      type: String
    }
  },
  created () {
    var self = this
    eventEmitter
      .$on('reportPreviewReload', function handleClose (fileData) {
        self.reportReload(fileData)
      })
  },
  methods: {
    closeDialog () {
      eventEmitter.$emit('closeReportPreviewModal')
    },
    reportReload (fileData) {
      this.state = {
        tabs: null,
        sheet: []
      }
      this.handleDrop(fileData)
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}
table, th, td {
  border: 1px solid black;
}
td {
  padding-left: 5px;
  padding-right: 5px;
}
.tab-item {
  font-size: medium;
}
.row {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/report-preview/ReportPreview.vue